// extracted by mini-css-extract-plugin
export default {"section":"myCard_section__J10C+","section__title":"myCard_section__title__0i+DC","text":"myCard_text__xhYM5","btn":"myCard_btn__DMDbJ","section__img":"myCard_section__img__z3MHL"};